"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NFT = exports.NFTSortBy = void 0;
const validation_1 = require("../validation");
const chain_id_1 = require("./chain-id");
const platform_1 = require("../platform");
const network_1 = require("./network");
const nft_category_1 = require("./nft-category");
const rarity_1 = require("./rarity");
const wearable_category_1 = require("../platform/item/wearable/wearable-category");
var NFTSortBy;
(function (NFTSortBy) {
    NFTSortBy["NAME"] = "name";
    NFTSortBy["NEWEST"] = "newest";
    NFTSortBy["RECENTLY_LISTED"] = "recently_listed";
    NFTSortBy["RECENTLY_SOLD"] = "recently_sold";
    NFTSortBy["CHEAPEST"] = "cheapest";
    NFTSortBy["RENTAL_LISTING_DATE"] = "rental_listing_date";
    NFTSortBy["RENTAL_DATE"] = "rented_date";
    NFTSortBy["MAX_RENTAL_PRICE"] = "max_rental_price";
    NFTSortBy["MIN_RENTAL_PRICE"] = "min_rental_price";
})(NFTSortBy = exports.NFTSortBy || (exports.NFTSortBy = {}));
var NFT;
(function (NFT) {
    NFT.schema = {
        type: 'object',
        properties: {
            id: {
                type: 'string'
            },
            tokenId: {
                type: 'string'
            },
            contractAddress: {
                type: 'string'
            },
            activeOrderId: {
                type: 'string',
                nullable: true
            },
            utility: {
                type: 'string',
                nullable: true
            },
            openRentalId: {
                type: 'string',
                nullable: true
            },
            owner: {
                type: 'string'
            },
            name: {
                type: 'string'
            },
            image: {
                type: 'string'
            },
            url: {
                type: 'string'
            },
            data: {
                type: 'object',
                nullable: false,
                properties: {
                    parcel: {
                        type: 'object',
                        properties: {
                            description: {
                                type: ['string'],
                                nullable: true
                            },
                            x: {
                                type: 'string'
                            },
                            y: {
                                type: 'string'
                            },
                            estate: {
                                type: 'object',
                                properties: {
                                    tokenId: {
                                        type: 'string'
                                    },
                                    name: {
                                        type: 'string'
                                    }
                                },
                                required: ['tokenId', 'name'],
                                nullable: true
                            }
                        },
                        required: ['description', 'x', 'y', 'estate'],
                        nullable: true
                    },
                    estate: {
                        type: 'object',
                        properties: {
                            description: {
                                type: ['string'],
                                nullable: true
                            },
                            size: {
                                type: 'integer'
                            },
                            parcels: {
                                type: 'array',
                                items: {
                                    type: 'object',
                                    properties: {
                                        x: {
                                            type: 'number'
                                        },
                                        y: {
                                            type: 'number'
                                        }
                                    },
                                    required: ['x', 'y']
                                }
                            }
                        },
                        required: ['description', 'size', 'parcels'],
                        nullable: true
                    },
                    wearable: {
                        type: 'object',
                        properties: {
                            bodyShapes: {
                                type: 'array',
                                items: platform_1.BodyShape.schema
                            },
                            category: wearable_category_1.WearableCategory.schema,
                            description: {
                                type: 'string'
                            },
                            rarity: rarity_1.Rarity.schema,
                            isSmart: {
                                type: 'boolean'
                            }
                        },
                        required: ['bodyShapes', 'category', 'description', 'rarity', 'isSmart'],
                        nullable: true
                    },
                    ens: {
                        type: 'object',
                        properties: {
                            subdomain: {
                                type: 'string'
                            }
                        },
                        required: ['subdomain'],
                        nullable: true
                    },
                    emote: {
                        type: 'object',
                        properties: {
                            bodyShapes: {
                                type: 'array',
                                items: platform_1.BodyShape.schema
                            },
                            category: platform_1.EmoteCategory.schema,
                            description: {
                                type: 'string'
                            },
                            rarity: rarity_1.Rarity.schema,
                            loop: {
                                type: 'boolean'
                            },
                            hasSound: {
                                type: 'boolean'
                            },
                            hasGeometry: {
                                type: 'boolean'
                            }
                        },
                        required: ['bodyShapes', 'category', 'description', 'rarity', 'loop'],
                        nullable: true
                    }
                },
                required: []
            },
            issuedId: {
                type: 'string',
                nullable: true
            },
            itemId: {
                type: 'string',
                nullable: true
            },
            category: nft_category_1.NFTCategory.schema,
            network: network_1.Network.schema,
            chainId: chain_id_1.ChainId.schema,
            createdAt: {
                type: 'integer'
            },
            updatedAt: {
                type: 'integer'
            },
            soldAt: {
                type: 'integer'
            },
            urn: {
                type: 'string',
                nullable: true
            }
        },
        required: [
            'id',
            'tokenId',
            'contractAddress',
            'activeOrderId',
            'openRentalId',
            'owner',
            'name',
            'image',
            'url',
            'data',
            'issuedId',
            'itemId',
            'category',
            'network',
            'chainId',
            'createdAt',
            'updatedAt',
            'soldAt'
        ]
    };
    NFT.validate = (0, validation_1.generateLazyValidator)(NFT.schema);
})(NFT = exports.NFT || (exports.NFT = {}));
//# sourceMappingURL=nft.js.map